export { IconDualColorRoot as Root } from './icon-dual-color-root'
export { IconDualColorTop as Top } from './icon-dual-color-top'
export { IconDualColorBottom as Bottom } from './icon-dual-color-bottom'
